import { Controller } from "@hotwired/stimulus"

// Cascade picker for the "Lié à" field : a type select + a searchable input
// that fetches /taches_pickers/taskable?type=...&q=... When the user picks an
// option, the corresponding hidden taskable_id is set.
export default class extends Controller {
  static targets = ["typeSelect", "search", "results", "hiddenId", "selected"]
  static values  = { searchUrl: String }

  connect() {
    this._timer = null
    this._renderSelected()
    document.addEventListener("click", this._onDoc = (e) => {
      if (!this.element.contains(e.target)) this._closeResults()
    })
    if (this.typeSelectTarget.value) {
      this.searchTarget.disabled = false
    }
  }

  disconnect() { document.removeEventListener("click", this._onDoc) }

  changeType() {
    if (this.hasHiddenIdTarget) this.hiddenIdTarget.value = ""
    if (this.hasSearchTarget) {
      this.searchTarget.value = ""
      this.searchTarget.disabled = !this.typeSelectTarget.value
      const labels = {
        Etude: "une étude", Phase: "une phase", Prospection: "une prospection",
        Contact: "un contact", Adherent: "un adhérent", Membre: "un membre",
        Entreprise: "une entreprise", Tresorerie: "un exercice",
        BulletinVersement: "un BV"
      }
      const t = this.typeSelectTarget.value
      this.searchTarget.placeholder = t ? `Rechercher ${labels[t] || "..."}` : "Sélectionne d'abord un type"
      if (t) this.searchTarget.focus()
    }
    this._renderSelected()
    this._closeResults()
  }

  search(event) {
    clearTimeout(this._timer)
    const q = event.target.value
    if (!this.typeSelectTarget.value) return
    this._timer = setTimeout(() => this._fetch(q), 200)
  }

  async _fetch(q) {
    const url = new URL(this.searchUrlValue, window.location.origin)
    url.searchParams.set("type", this.typeSelectTarget.value)
    url.searchParams.set("q",    q || "")
    const res = await fetch(url.toString(), { headers: { Accept: "application/json" } })
    if (!res.ok) return
    const data = await res.json()
    this._renderResults(data)
  }

  _renderResults(items) {
    this.resultsTarget.innerHTML = ""
    if (!items.length) {
      this.resultsTarget.innerHTML = `<div class="picker__empty">Aucun résultat</div>`
    } else {
      items.forEach((it) => {
        const row = document.createElement("button")
        row.type = "button"
        row.className = "picker__result"
        row.innerHTML = `<i class="fa-solid fa-link"></i><span class="picker__result-label">${this._escape(it.label)}</span>`
        row.addEventListener("click", (event) => {
          event.preventDefault()
          event.stopPropagation()
          this._select(it)
        })
        this.resultsTarget.appendChild(row)
      })
    }
    this._positionResults()
    this.resultsTarget.classList.add("picker__results--open")
  }

  _positionResults() {
    if (!this.hasSearchTarget || !this.hasResultsTarget) return
    const rect = this.searchTarget.getBoundingClientRect()
    this.resultsTarget.style.top   = `${rect.bottom + 4}px`
    this.resultsTarget.style.left  = `${rect.left}px`
    this.resultsTarget.style.width = `${rect.width}px`
  }

  _select(item) {
    if (this.hasHiddenIdTarget) this.hiddenIdTarget.value = item.id
    if (this.hasSearchTarget)   this.searchTarget.value = item.label
    if (this.hasSelectedTarget) {
      this.selectedTarget.innerHTML = `
        <span class="picker__chip">
          <i class="fa-solid fa-link"></i>
          <span class="picker__chip-label">${this._escape(item.label)}</span>
          <button type="button" class="picker__chip-remove" data-action="click->taskable-picker#clearSelection">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </span>`
    }
    this._closeResults()
  }

  clearSelection() {
    if (this.hasHiddenIdTarget) this.hiddenIdTarget.value = ""
    if (this.hasSearchTarget)   this.searchTarget.value = ""
    if (this.hasSelectedTarget) this.selectedTarget.innerHTML = ""
  }

  _renderSelected() {
    if (this.hasSelectedTarget && this.hiddenIdTarget?.value && this.searchTarget?.value) {
      this.selectedTarget.innerHTML = `
        <span class="picker__chip">
          <i class="fa-solid fa-link"></i>
          <span class="picker__chip-label">${this._escape(this.searchTarget.value)}</span>
          <button type="button" class="picker__chip-remove" data-action="click->taskable-picker#clearSelection">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </span>`
    } else if (this.hasSelectedTarget) {
      this.selectedTarget.innerHTML = ""
    }
  }

  _closeResults() {
    this.resultsTarget.innerHTML = ""
    this.resultsTarget.classList.remove("picker__results--open")
  }

  _escape(s) {
    const div = document.createElement("div")
    div.textContent = String(s ?? "")
    return div.innerHTML
  }
}
